export const styles = theme => ({
  titleRootWrapper: {
    marginBottom: theme.spacing.unit * 5,

    '& a': {
      color: theme.typography.color.main,
      textDecoration: 'none'
    },
    '& a:hover': {
      color: theme.typography.color.primary,
      textDecoration: 'none'
    }
  },
  cardStat: {
    fontFamily: theme.typography.font.second,
    fontSize: '28.54px',
    fontWeight: 400,
    lineHeight: '41px',

    '@media (min-width:1440px)': {
      fontSize: '34.54px'
    }
  },
  cardLabel: {
    fontWeight: 500
  },
  filterOptionsWrapper: {
    height: 88,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    marginBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3
  },
  summaryCard: {
    marginBottom: theme.spacing.unit * 5
  },
  loadingOrError: {
    padding: theme.spacing.unit * 3,
    position: 'relative',
    minHeight: 68
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  }
});

export default styles;
